import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ErrorMessage, Field, FieldProps, Form, Formik, FormikErrors } from "formik";
import { PatternFormat } from "react-number-format";
import Logo from "user/components/common/Logo";
import { errorMsgHandler } from "common/hooks/utils/utils";
import { usePostLogin } from "common/hooks/user/account/usePostLogin";
import Spinner from "common/components/spinner";
import loginBG from "../../assets/images/loginBG.png";
import { ReactComponent as IdIcon } from "../../assets/icons/idIcon.svg";
import { ReactComponent as PwIcon } from "../../assets/icons/pwIcon.svg";
import { ReactComponent as ReadPassword } from "../../assets/icons/readPassword.svg";
import { ReactComponent as UnreadPassword } from "../../assets/icons/unreadPassword.svg";

type InitialValuesProps = {
    m_category: string;
    m_mobile: string;
    m_password: string;
};
const initialValues: InitialValuesProps = {
    m_category: "1",
    m_mobile: "",
    m_password: "",
};
const labelStyle =
    // twMerge(
    "flex-1 py-[11px] text-center border-box rounded-[8px] text-[#4B632B] border border-transparent has-[:checked]:bg-white has-[:checked]:border-primary2 has-[:checked]:shadow-custom has-[:checked]:text-[#484964]";
// );

const Login = () => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setPasswordVisible(prev => !prev);
    };

    const { mutate, isPending } = usePostLogin();

    const onSubmit = async (values: InitialValuesProps, setErrors: (errors: FormikErrors<InitialValuesProps>) => void) => {
        // console.log(values);

        const body = {
            m_category: Number(values.m_category),
            m_mobile: values.m_mobile,
            m_password: values.m_password,
        };

        mutate(
            { ...body },
            {
                onSuccess: () => {
                    navigate("/");
                },
                onError: error => {
                    const err_msg = errorMsgHandler(error);
                    setErrors({
                        m_mobile: err_msg,
                        m_password: err_msg,
                    });
                },
            },
        );
    };

    return (
        <div
            className="min-h-[100dvh] gap-20 flex-col flex bg-cover bg-center bg-no-repeat items-center relative pt-[160px] pb-[190px] px-[40px] mobile450:pt-[40px] mobile450:pb-[110px] mobile450:px-[28px]"
            style={{
                backgroundImage: `url(${loginBG})`,
            }}
        >
            {isPending && <Spinner />}
            <div className="flex flex-col items-center w-full [&_form]:w-full gap-[80px] mobile450:gap-[40px]">
                <Logo className="w-[245px] h-[60px] [&_a]:!w-full [&_a]:!h-full [&_a]:!bg-contain mobile450:w-[147px] mobile450:h-[36px]" />
                <Formik
                    initialValues={initialValues}
                    // validateOnMount
                    validate={values => {
                        // const { mobile, password } = values;
                        const errors: Record<string, string> = {};
                        if (!values.m_mobile) {
                            errors.m_mobile = "연락처를 입력해주세요.";
                        }
                        if (!values.m_password) {
                            errors.m_password = "비밀번호를 입력해주세요.";
                        }
                        return errors;
                    }}
                    onSubmit={(values, { setSubmitting, setErrors }) => {
                        setSubmitting(true);
                        onSubmit(values, setErrors);
                    }}
                >
                    {({ isSubmitting, errors, values, setFieldValue, setValues, touched }) => {
                        const errorKeys = Object.keys(errors);
                        // const isInValid = errorKeys.length > 0;

                        return (
                            <Form>
                                <div className="flex flex-col gap-6">
                                    <div className="flex flex-col gap-3">
                                        {/* <CategoryTab /> */}

                                        <div role="group" className="bg-primary3 rounded-[8px] p-[4px] flex">
                                            <label className={labelStyle}>
                                                <Field type="radio" name="m_category" value="1" className="appearance-none" />
                                                회사
                                            </label>
                                            <label className={labelStyle}>
                                                <Field type="radio" name="m_category" value="2" className="appearance-none" />
                                                개인
                                            </label>
                                        </div>

                                        <div className="flex flex-col gap-2">
                                            <div
                                                className={`flex gap-2 p-3 rounded-xl border bg-white items-center ${touched.m_mobile && errorKeys.includes("m_mobile") ? "[&:has(input)]:border-[#DC2626]" : "[&:has(input:focus)]:border-[#4B632B]"}`}
                                            >
                                                <IdIcon />
                                                <Field name="m_mobile">
                                                    {({ field, form, meta }: FieldProps) => {
                                                        return (
                                                            <PatternFormat
                                                                format="###-####-####"
                                                                id="m_mobile"
                                                                placeholder="연락처"
                                                                value={values.m_mobile}
                                                                onChange={field.onChange}
                                                                className="placeholder:text-gray3 text-lg focus:outline-none focus:ring-0 w-full"
                                                            />
                                                        );
                                                    }}
                                                </Field>
                                            </div>
                                            <ErrorMessage
                                                name="m_mobile"
                                                render={message => <div className="text-[#DC2626] flex gap-[6px]">{message}</div>}
                                            />

                                            <div
                                                className={`flex gap-2 p-3 rounded-xl border bg-white items-center ${touched.m_password && errorKeys.includes("m_password") ? "[&:has(input)]:border-[#DC2626]" : "[&:has(input:focus)]:border-[#4B632B]"}`}
                                            >
                                                <PwIcon />
                                                <Field
                                                    type={passwordVisible ? "text" : "password"}
                                                    id="m_password"
                                                    name="m_password"
                                                    placeholder="비밀번호"
                                                    className="placeholder:text-gray3 text-lg focus:outline-none focus:ring-0 w-full"
                                                />
                                                {passwordVisible ? (
                                                    <ReadPassword className="cursor-pointer ml-auto" onClick={togglePasswordVisibility} />
                                                ) : (
                                                    <UnreadPassword className="cursor-pointer ml-auto" onClick={togglePasswordVisibility} />
                                                )}
                                            </div>
                                            <ErrorMessage
                                                name="m_password"
                                                render={message => <div className="text-[#DC2626] flex gap-[6px]">{message}</div>}
                                            />
                                        </div>
                                        <Link to="/find-password" className="text-sm text-gray2 text-end self-end">
                                            비밀번호 찾기
                                        </Link>
                                    </div>
                                    <div>
                                        <div className="grid grid-cols-2 gap-2">
                                            <button
                                                type="submit"
                                                className="shadow-custom bg-gradient-to-r from-[#273219] to-[#4B632B] text-white font-bold text-[18px] leading-[28px] py-[27px] rounded-[12px] flex-1 w-full"
                                            >
                                                로그인
                                            </button>
                                            <div
                                                onClick={() => navigate("/login-non-member")}
                                                className="shadow-custom relative cursor-pointer bg-[#7D4C16] px-2 py-[27px] rounded-[12px] flex-1 flex flex-col items-center justify-center"
                                            >
                                                <span className="text-[#ffffff] font-[500] text-[18px] leading-[28px]">비회원</span>
                                                <p className="absolute bottom-[13px] text-[13px] text-center mt-1 text-white break-keep opacity-[0.7] leading-[17px]">[가입없이 이용가능]</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
            <div className="flex flex-col items-center">
                {/* <p className="text-sm font-bold">이메일로 간단하게 서비스를 이용하세요~!</p> */}
                <Link to="/terms" className="text-lg font-bold underline p-3 ">
                    회원가입
                </Link>
                <p className="text-gray3 text-sm">Copyright &copy; 2025. (주)고려원예</p>
            </div>
        </div>
    );
};
export default Login;
